// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"8102e2306588b998","3795":"5c99b448dbfc4eee","6929":"5c99b448dbfc4eee","8269":"12bb05bc15728ac6"}[chunkId] + ".css";
};